import React from 'react';
import {Link} from 'react-router-dom';
import {HashLink} from "react-router-hash-link";
import { AppBar, Drawer, RaisedButton, List, ListItem, FlatButton} from 'material-ui';
import {isEmpty} from "lodash";
import language, {languages} from "../constants/languages";
import {BACKGROUND_COLOR, TEXT_COLOR} from "../constants/colours";

const mainLogoImg = 'images/ascend_logo.png';
const windowWidth = 992 ;
const LeftMenu = () => {
    const listStyle = {
        backgroundColor: '#1E1A3D', // --dark-surface
        color: '#FFFFFF',
        padding: '20px 0'
    };

    const listItemStyle = {
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: '600',
        padding: '12px 16px'
    };

    const innerDivStyle = {
        paddingLeft: '50px'
    };

    return window.innerWidth <= windowWidth && <List style={listStyle}>
        <ListItem
            key={3}
            primaryText='About Us'
            style={listItemStyle}
            containerElement={<Link to="/about_us"/>}
            innerDivStyle={innerDivStyle}
            hoverColor="rgba(146, 90, 148, 0.2)"
        />
        <ListItem
            key={4}
            primaryText='Partner With Us'
            style={listItemStyle}
            containerElement={<Link to="/partner_with_us"/>}
            innerDivStyle={innerDivStyle}
            hoverColor="rgba(146, 90, 148, 0.2)"
        />
        <ListItem
            key={5}
            primaryText='EMI Calculator'
            style={listItemStyle}
            containerElement={<Link to="/emi_calculator"/>}
            innerDivStyle={innerDivStyle}
            hoverColor="rgba(146, 90, 148, 0.2)"
        />
        <ListItem
            key={6}
            primaryText='Apply'
            style={listItemStyle}
            containerElement={<Link to="/apply"/>}
            innerDivStyle={innerDivStyle}
            hoverColor="rgba(146, 90, 148, 0.2)"
        />
    </List>
}

const Logo = () => {
    return <div className="col-sm-3 col-6 col-lg-2 col-xl-2 order-lg-1">
        <Link to={"/"}><div className="row align-items-center brand">
            <div className="col-5"><img src={mainLogoImg} alt=""/></div>
            <div className="col-7"><span className="brand_name">ASCEND CAPITAL</span></div>
        </div></Link>
    </div>
}

const Header = () => {
    return (
  <header className="site-header-dark">
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 10px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: 70,
          gap: 24,
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={mainLogoImg} alt="" style={{ height: 38, width: 'auto' }} />
            <span className="brand-text-dark">
              ASCEND CAPITAL
            </span>
          </div>
        </Link>

        {/* Menu */}
        <nav style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <ul
            style={{
              listStyle: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 26,
              margin: 0,
              padding: 0,
              whiteSpace: 'nowrap',
            }}
          >
            <li>
              <Link to="/about_us" className="nav-link-dark">
                About Us
              </Link>
            </li>
            <li>
              <HashLink to="/partner_with_us" className="nav-link-dark">
                Partner With Us
              </HashLink>
            </li>
            <li>
              <Link to="/emi_calculator" className="nav-link-dark">
                EMI Calculator
              </Link>
            </li>
          </ul>
        </nav>

        {/* Buttons (only if condition true) */}
        {(window.innerWidth > windowWidth) && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <Link to="/apply" className="btn-apply-dark">
              Apply Loan
            </Link>
            <a
              href="https://partners.evcred.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-partner-dark"
            >
              Partner Login
            </a>
          </div>
        )}
      </div>
    </div>
  </header>
)
}

class HeaderNew extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            openMenu: false,
            width: window.innerWidth,
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    toggleMenuDrawer = () => {
        this.setState({
            openMenu: !this.state.openMenu
        });
    }

    closeMenuDrawer = () => {
        this.setState({ openMenu: false });
    }

    handleTitleTouchTap = () => {
        this.props.history.push('/');
    }

    handleChange = (value) => {
        this.props.setDefaultLanguage(value)
    }

    render() {
        const { width } = this.state;
        const isMobile = width < windowWidth;
        return(
            <header className="site-header-dark" style={{ borderBottom: 'none' }}>
                <div className="container" style={{ maxWidth: '100%', padding: 0 }}>
                    {window.innerWidth >= windowWidth &&  <Header/>}
                    {window.innerWidth < windowWidth && <div>
                        <AppBar
                            showMenuIconButton={isMobile}
                            zDepth={0}
                            style={{ 
                                backgroundColor: '#0F0C29',
                                borderBottom: '1px solid rgba(255,255,255,0.05)',
                                height: 70,
                                paddingTop: 10
                            }}
                            titleStyle={{ 
                                color: '#FFFFFF',
                                fontFamily: '"Open Sans", sans-serif',
                                fontWeight: '700',
                                fontSize: '18px',
                                marginTop: 15 
                            }}
                            className="app-header"
                            onTitleClick={() => {
                                this.handleTitleTouchTap();
                            }}
                            onLeftIconButtonClick={() => {
                                this.toggleMenuDrawer();
                            }}
                            iconElementRight={
                                <Logo/>
                            }
                        />
                        <Drawer 
                            open={this.state.openMenu} 
                            onRequestChange={openMenu => this.setState({ openMenu })} 
                            width={300} 
                            docked={false}
                            containerStyle={{ backgroundColor: '#1E1A3D' }}
                        >
                            <AppBar
                                style={{
                                    backgroundColor: '#0F0C29',
                                    borderBottom: '1px solid rgba(255,255,255,0.05)'
                                }}
                                title="ASCEND CAPITAL"
                                titleStyle={{ 
                                    color: '#FFFFFF',
                                    fontFamily: '"Open Sans", sans-serif',
                                    fontWeight: '700',
                                    fontSize: '18px'
                                }}
                                onTitleClick={() => {
                                    this.handleTitleTouchTap();
                                    this.closeMenuDrawer();
                                }}
                                showMenuIconButton={false}
                            />
                            <LeftMenu onCategoryClick={this.closeMenuDrawer}
                                      // selectedLanguage={this.props.selectedLanguage}
                                      handleChange={this.handleChange}
                                      // otherLanguage={this.props.otherLanguage}
                            />
                        </Drawer>
                    </div>}
                </div>
            </header>

        );
    }
}



export default HeaderNew;



// WEBPACK FOOTER //
// ./src/components/HeaderNew.js